import { render, staticRenderFns } from "./PhoneSilentForApp.vue?vue&type=template&id=f036fd6a&"
import script from "./PhoneSilentForApp.vue?vue&type=script&lang=js&"
export * from "./PhoneSilentForApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports